var _excluded = ["hasUpgrade", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import NewButton from './Button';
import LegacyButton from './LegacyButton';
var buttonPropTypes = {
  /** Upgrade to the new Button api */
  hasUpgrade: PropTypes.bool,
  /** The buttons content */
  children: PropTypes.node
};
var buttonDefaultProps = {
  hasUpgrade: false,
  children: 'My Button'
};
var Button = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var hasUpgrade = _ref.hasUpgrade,
    children = _ref.children,
    other = _objectWithoutProperties(_ref, _excluded);
  if (hasUpgrade) {
    return /*#__PURE__*/React.createElement(NewButton, _extends({}, other, {
      ref: forwardedRef
    }), children);
  } else return /*#__PURE__*/React.createElement(LegacyButton, _extends({}, other, {
    ref: forwardedRef
  }), children);
});
Button.propTypes = buttonPropTypes;
Button.defaultProps = buttonDefaultProps;
Button.displayName = 'Button';
export default Button;